const CheckboxItem = ({
  name,
  value,
  checked,
  none,
  disabled,
  onChange,
  orText = "ή",
}) => {
  return (
    <>
      {none && <div class="govgr-checkboxes__divider">{orText}</div>}
      <div className="govgr-checkboxes__item">
        <label className="govgr-label govgr-checkboxes__label">
          {value}
          <input
            className="govgr-checkboxes__input"
            disabled={disabled}
            checked={checked}
            onChange={onChange}
            type="checkbox"
            name={name}
            value={value}
          />
        </label>
      </div>
    </>
  );
};

export default CheckboxItem;
